import {
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Tooltip,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InformationCircleIcon } from 'src/legacy/components/Icons';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { LightGray } from 'src/theme/colors';
import { SidebarShadow } from 'src/theme/shadows';

import { SignatureSidebarInputs } from './SignatureSidebarInputs';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    signaturePageSidebar: {
      padding: theme.spacing(1.5),
      boxShadow: SidebarShadow,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    signaturePageSidebarActions: {
      margin: `${theme.spacing(2)}px 0`,
    },
    inputTitle: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    clientInputTitle: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(3),
    },
    infoIcon: {
      color: LightGray,
      fontSize: 12,
    },
    infoIconButton: {
      padding: theme.spacing(0),
    },
  }),
);

export interface BaseSignaturePageSidebarProps {
  selectedClientId?: string;
  signaturePlaceholderComponentElement: HTMLButtonElement | null;
}

export const BaseSignaturePageSidebar: React.FC<
  BaseSignaturePageSidebarProps
> = ({ signaturePlaceholderComponentElement, selectedClientId }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.signaturePageSidebar}>
      <div>
        <div className={classes.signaturePageSidebarActions}>
          <div>
            <div className={classes.inputTitle}>
              <BaseTypography fontType="13Medium">
                {t(
                  ($) =>
                    $.page_contracts.signature_step_title.current_user.title,
                )}
              </BaseTypography>
              <Tooltip
                title={t(
                  ($) =>
                    $.page_contracts.signature_step_title.current_user
                      .description,
                )}
                placement="bottom"
              >
                <IconButton className={classes.infoIconButton}>
                  <InformationCircleIcon className={classes.infoIcon} />
                </IconButton>
              </Tooltip>
            </div>
            <SignatureSidebarInputs
              isClientSignatureButton={false}
              signatureClientId={selectedClientId}
              signaturePlaceholderComponentElement={
                signaturePlaceholderComponentElement
              }
            />
            <div className={classes.clientInputTitle}>
              <BaseTypography fontType="13Medium">
                {t(($) => $.page_contracts.signature_step_title.client.title)}
              </BaseTypography>
              <Tooltip
                title={t(
                  ($) =>
                    $.page_contracts.signature_step_title.client.description,
                )}
                placement="bottom"
              >
                <IconButton className={classes.infoIconButton}>
                  <InformationCircleIcon className={classes.infoIcon} />
                </IconButton>
              </Tooltip>
            </div>
            <SignatureSidebarInputs
              isClientSignatureButton
              signatureClientId={selectedClientId}
              signaturePlaceholderComponentElement={
                signaturePlaceholderComponentElement
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
